import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AUTHENTICATED_ADMIN_ENTRY,
  AUTHENTICATED_ENTRY,
  UNCOMPLETED_AGENCY_PROFILE_PATH,
  UNCOMPLETED_CANDIDATE_PROFILE_PATH,
} from "configs/AppConfig";
import { onBlankLayout } from "store/slices/themeSlice";
import { USER_INFO } from "constants/AuthConstant";
import { AESEncrypt } from "utils/encryption";

const PublicRoute = () => {
  const dispatch = useDispatch();
  const { token, isCompletedProfile, candidateId, agencyId, role } =
    useSelector((state) => state.auth);

  useEffect(() => {
    const blankLayout =
      (agencyId || candidateId) && !isCompletedProfile ? true : false;

    dispatch(onBlankLayout(blankLayout));
  }, []);

  const navigateTo = () => {
    if (!isCompletedProfile) {
      if (candidateId) {
        return UNCOMPLETED_CANDIDATE_PROFILE_PATH + AESEncrypt(candidateId);
      } else if (agencyId) {
        return UNCOMPLETED_AGENCY_PROFILE_PATH + AESEncrypt(agencyId);
      } else {
        return AUTHENTICATED_ENTRY;
      }
    } else {
      if (role === "Admin") {
        return AUTHENTICATED_ADMIN_ENTRY;
      }
      return AUTHENTICATED_ENTRY;
    }
  };
  return token ? <Navigate to={navigateTo()} /> : <Outlet />;
};

export default PublicRoute;
